import { format } from 'date-fns';
import { DATETIME_SECONDS_FORMAT } from '../../../common/common.constants';

export const getAvailableStandardName = (currentName: string) => ({
  standardName: currentName,
  identifier: format(new Date(), DATETIME_SECONDS_FORMAT),
});
